'use strict';

import { confirmPasswordState, resetPasswordState, resetPasswordVerificationState } from './resetPassword.states';
import { ResetPasswordFormComponent } from './resetPasswordForm/resetPasswordForm.component';
import { ResetPasswordVerificationComponent } from './resetPasswordVerification/resetPasswordVerification.component';
import { ResetPasswordService } from './resetPassword.service';
import { ConfirmPasswordFromComponent } from './confirmPasswordForm/confirmPasswordForm.component';

export const signUpModule = angular
	.module('mx.sb.ResetPassword', [])
	.component(resetPasswordState.component, ResetPasswordFormComponent)
	.component(resetPasswordVerificationState.component, ResetPasswordVerificationComponent)
	.component(confirmPasswordState.component, ConfirmPasswordFromComponent)
	.service('mx.sb.ResetPasswordService', ResetPasswordService);
